import { createTheme } from "@mui/material/styles";

export const appTheme = createTheme({
  spacing: factor => `${1 * factor}em`,
});
